import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const username = localStorage.getItem("username");
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  // Logout
  const handleLogout = async () => {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.removeItem("roleid");
    localStorage.removeItem("username");
    localStorage.removeItem("userid");
    localStorage.removeItem("rolename");
    // Clear Local Storage
  localStorage.clear();

  // Clear Session Storage
  sessionStorage.clear();

  // Clear Cache Storage
  if ("caches" in window) {
    const cacheNames = await caches.keys();

    await Promise.all(
      cacheNames.map((cache) =>
        caches.delete(cache)
      )
    );
  }
    //navigate("/");
    // Redirect to login page
        navigate("/", { replace: true });
        // Force full refresh
        window.location.reload();
  };

  // Close dropdown outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );
    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };
  }, []);
  return (
    <nav
      className="navbar navbar-expand-lg fixed-top px-3"
      style={{
        background: "#f40808",
        height: "52px",
        zIndex: 1050,
      }}
    >
      {/* Left */}
      <div className="d-flex align-items-center gap-4 text-white">
        <h5 className="mb-0 fw-bold">AyurMax Life</h5>

        <i className="fa fa-bars fs-5" role="button"></i>
      </div>

      {/* Right */}
      <div
        className="ms-auto position-relative"
        ref={dropdownRef}
      >
        {/* User Info */}
        <div
          className="d-flex align-items-center gap-2 text-white fw-bold small"
          style={{ cursor: "pointer" }}
          onClick={() => setOpen(!open)}
        >
          <img
            src="https://i.pravatar.cc/100"
            alt="profile"
            className="rounded-circle"
            width="30"
            height="30"
          />

          <span>{username}</span>
        </div>

        {/* Dropdown */}
        {open && (
          <div
            className="position-absolute bg-white shadow"
            style={{
              right: 0,
              top: "45px",
              width: "280px",
              zIndex: 9999,
              borderRadius: "4px",
              overflow: "hidden",
            }}
          >
            {/* Top Section */}
            <div
              className="text-center text-white py-4"
              style={{ background: "#00b050" }}
            >
              <img
                src="https://i.pravatar.cc/100"
                alt="profile"
                className="rounded-circle border border-3 border-light mb-3"
                width="100"
                height="100"
              />

              <h5 className="mb-0">
                {username} - Admin
              </h5>
            </div>

            {/* Bottom Buttons */}
            <div className="d-flex justify-content-between p-3">
              <button className="btn btn-light border">
                Profile
              </button>

              <button
                className="btn btn-light border"
                onClick={handleLogout}
              >
                Sign out
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );

}
export default Header;